module.exports = __webpack_public_path__ + "img/image22.45c8b5f2.png";